import { __assign, __awaiter, __generator } from "tslib";
import { logTaggedMessage } from '../../reporter';
import { stringify } from '../../../utils';
import { renderIframeAndWaitForPostback, ThreeDsFormattingException, } from '../3d-secure';
import { threeDsErrors } from '../3ds-utils';
import { removeChallengeIframe } from '../iframe-handler';
var log = logTaggedMessage({ module: '3ds', sub_module: 'adyen_v1fallback' });
var parseV1FallbackPostData = function (postData) {
    if (typeof postData !== 'object' ||
        !postData.PaRes ||
        !postData.MD) {
        throw new ThreeDsFormattingException("failed to decode invalid V1FallbackResponsePostData.cres: ".concat(stringify(postData)));
    }
    return postData;
};
export var performV1Fallback = function (_a) {
    var methodUrl = _a.methodUrl, actionData = _a.data, provider = _a.provider, notificationUrl = _a.notificationUrl;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, md, paRequest, success, fail, postData, logData, v1FallbackResultPromise, v1FallbackResult, e_1, ret;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _b = actionData, md = _b.md, paRequest = _b.paRequest;
                    success = function (_a) {
                        var MD = _a.MD, PaRes = _a.PaRes;
                        return ({
                            v1FallbackData: {
                                received: {},
                                provider: provider,
                                data: {
                                    md: MD,
                                    paResponse: PaRes,
                                    shopperIp: '',
                                },
                            },
                        });
                    };
                    fail = function (error) {
                        return {
                            v1FallbackData: {
                                provider: provider,
                                notReceived: { error: error },
                                data: {
                                    md: '',
                                    paResponse: '',
                                    shopperIp: '',
                                },
                            },
                        };
                    };
                    postData = {
                        PaReq: paRequest,
                        TermUrl: notificationUrl,
                        MD: md,
                    };
                    logData = {
                        actionData: actionData,
                        methodUrl: methodUrl,
                        provider: provider,
                        postData: postData,
                    };
                    log('3ds: before render 3ds Adyen V1fallback iframe', logData);
                    v1FallbackResultPromise = renderIframeAndWaitForPostback('visible', methodUrl, 'POST', postData).then(parseV1FallbackPostData);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, v1FallbackResultPromise];
                case 2:
                    v1FallbackResult = _c.sent();
                    log('3ds: received Adyen v1Fallback success', __assign(__assign({}, logData), { v1FallbackResult: v1FallbackResult }));
                    return [2 /*return*/, success(v1FallbackResult)];
                case 3:
                    e_1 = _c.sent();
                    ret = fail(threeDsErrors.generate3dsError({
                        providerFlow: 'Fallback',
                        step: 'challenge',
                        e: e_1,
                    }));
                    log('3ds: Adyen v1Fallback ERROR', __assign(__assign({}, logData), { e: e_1, ret: ret }));
                    return [2 /*return*/, ret];
                case 4:
                    removeChallengeIframe();
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    });
};
//# sourceMappingURL=adyen-v1fallback.js.map